import type { GameHistoryData } from "@slot/game-shell";

/**
 * slot-cannon's offline history, served by the shell's `FixtureGameHistoryProvider`: eleven bet rows, newest first (the
 * first a failed round; 4015571829392, the 8700 win, the round the offline replay plays as the free spins), and the
 * two leaderboards. No row carries a replayUrl: the history page builds each row's link from its round id
 * (GameHistoryPresenter).
 */
export const HISTORY_FIXTURE: GameHistoryData = {
  betHistory: [
    {
      gameName: "slot-cannon",
      date: "2025-04-15 14:33",
      betAmountMinor: "100",
      winAmountMinor: "0",
      roundId: "4015571829402",
      replayUrl: null,
      currencyCode: "USD",
      status: "failed",
      chargeAmountMinor: "100",
      costMultiplier: 1,
    },
    {
      gameName: "slot-cannon",
      date: "2025-04-15 14:32",
      betAmountMinor: "100",
      winAmountMinor: "12000",
      roundId: "4015571829401",
      replayUrl: null,
      currencyCode: "USD",
      status: "completed",
      chargeAmountMinor: "10000",
      costMultiplier: 100,
      featureIdentifier: "super_bonus_buy",
    },
    {
      gameName: "slot-cannon",
      date: "2025-04-15 14:31",
      betAmountMinor: "200",
      winAmountMinor: "580",
      roundId: "4015571829400",
      replayUrl: null,
      currencyCode: "USD",
      status: "completed",
      chargeAmountMinor: "200",
      costMultiplier: 1,
    },
    {
      gameName: "slot-cannon",
      date: "2025-04-15 14:30",
      betAmountMinor: "100",
      winAmountMinor: "1250",
      roundId: "4015571829399",
      replayUrl: null,
    },
    {
      gameName: "slot-cannon",
      date: "2025-04-15 14:28",
      betAmountMinor: "100",
      winAmountMinor: "0",
      roundId: "4015571829398",
      replayUrl: null,
    },
    {
      gameName: "slot-cannon",
      date: "2025-04-15 14:27",
      betAmountMinor: "100",
      winAmountMinor: "340",
      roundId: "4015571829397",
      replayUrl: null,
    },
    {
      gameName: "slot-cannon",
      date: "2025-04-15 14:25",
      betAmountMinor: "500",
      winAmountMinor: "0",
      roundId: "4015571829396",
      replayUrl: null,
    },
    {
      gameName: "slot-cannon",
      date: "2025-04-15 14:23",
      betAmountMinor: "500",
      winAmountMinor: "4200",
      roundId: "4015571829395",
      replayUrl: null,
    },
    {
      gameName: "slot-cannon",
      date: "2025-04-15 14:20",
      betAmountMinor: "200",
      winAmountMinor: "0",
      roundId: "4015571829394",
      replayUrl: null,
    },
    {
      gameName: "slot-cannon",
      date: "2025-04-15 14:18",
      betAmountMinor: "200",
      winAmountMinor: "150",
      roundId: "4015571829393",
      replayUrl: null,
    },
    {
      gameName: "slot-cannon",
      date: "2025-04-15 14:16",
      betAmountMinor: "1000",
      winAmountMinor: "8700",
      roundId: "4015571829392",
      replayUrl: null,
    },
  ],
  biggestWinsAllGames: [
    {
      gameName: "Other Game A",
      date: "2025-04-10 09:12",
      betAmountMinor: "2000",
      winAmountMinor: "185000",
      roundId: "4015571820100",
      replayUrl: null,
    },
    {
      gameName: "Other Game B",
      date: "2025-04-08 22:45",
      betAmountMinor: "1000",
      winAmountMinor: "52300",
      roundId: "4015571818200",
      replayUrl: null,
    },
    {
      gameName: "slot-cannon",
      date: "2025-03-29 15:33",
      betAmountMinor: "500",
      winAmountMinor: "24100",
      roundId: "4015571810050",
      replayUrl: null,
    },
  ],
  biggestWinsCurrentGame: [
    {
      gameName: "slot-cannon",
      date: "2025-04-15 14:16",
      betAmountMinor: "1000",
      winAmountMinor: "8700",
      roundId: "4015571829392",
      replayUrl: null,
    },
    {
      gameName: "slot-cannon",
      date: "2025-04-15 14:23",
      betAmountMinor: "500",
      winAmountMinor: "4200",
      roundId: "4015571829395",
      replayUrl: null,
    },
  ],
};
